var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItSoftware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209.969,
    height: 209.969,
    viewBox: "0 0 209.969 209.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IT_Software",
    "data-name": "IT & Software",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M215.47,16H26.5A10.51,10.51,0,0,0,16,26.5V180.476a10.51,10.51,0,0,0,10.5,10.5H98.784l-8.4,28H78.991v7h83.988v-7H151.584l-8.4-28h72.285a10.51,10.51,0,0,0,10.5-10.5V26.5a10.51,10.51,0,0,0-10.5-10.5ZM144.277,218.97H97.692l8.4-28h29.787Zm74.693-38.494a3.5,3.5,0,0,1-3.5,3.5H26.5a3.5,3.5,0,0,1-3.5-3.5v-10.5H218.97Zm0-17.5H23V26.5A3.5,3.5,0,0,1,26.5,23H215.47a3.5,3.5,0,0,1,3.5,3.5Z",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M291.483,134H245.389a3.476,3.476,0,0,1-2.475-1.025l-9.9-9.9A10.43,10.43,0,0,0,225.593,120H186.5A10.51,10.51,0,0,0,176,130.5v73.489a10.51,10.51,0,0,0,10.5,10.5H291.482a10.511,10.511,0,0,0,10.5-10.5V144.5a10.511,10.511,0,0,0-10.5-10.5Zm3.5,69.99a3.5,3.5,0,0,1-3.5,3.5H186.5a3.5,3.5,0,0,1-3.5-3.5V130.5a3.5,3.5,0,0,1,3.5-3.5h39.095a3.476,3.476,0,0,1,2.475,1.025l9.9,9.9A10.43,10.43,0,0,0,245.389,141h46.094a3.5,3.5,0,0,1,3.5,3.5Z",
    transform: "translate(-90.01 -58.507)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M240.659,194.343l-19.972,19.972,19.972,19.972,4.949-4.949-15.023-15.023,15.023-15.023Z",
    transform: "translate(-115.15 -100.33)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M0,0H36.029V7H0Z",
    transform: "translate(138.952 129.845) rotate(-60.923)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M362.343,199.292l15.023,15.023-15.023,15.023,4.949,4.949,19.972-19.972-19.972-19.972Z",
    transform: "translate(-194.84 -100.33)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M115.712,55l5.667,13.219,12.5,5.178,13.376-5.345,6.92,6.92,4.949-4.949L148.94,59.84l-15.015,6-7.235-3L120.327,48H101.654L95.292,62.842l-7.236,3-15.015-6-13.2,13.2,6,15.015-3,7.235L48,101.654v18.672l14.842,6.363,3,7.235-6,15.015,13.2,13.2,15.015-6,7.6,3.148,2.68-6.466L88.1,148.585,74.728,153.93l-6.677-6.677L73.4,133.877l-5.179-12.5L55,115.712v-9.443L68.218,100.6,73.4,88.1,68.051,74.728l6.677-6.677L88.1,73.4l12.5-5.178L106.269,55Z",
    transform: "translate(-18.002 -18.002)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M134.554,126.588l-3.115-6.268a35.007,35.007,0,0,0,0,62.71l3.115-6.268a28.008,28.008,0,0,1,0-50.175Z",
    transform: "translate(-54.006 -58.687)",
    fill: "#1c6bfe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItSoftware);
export default __webpack_public_path__ + "static/media/IT & Software.112b99ab364d906ac322129307ab5812.svg";
export { ForwardRef as ReactComponent };